import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Form, FormGroup, Col, Input, Button, FormFeedback } from 'reactstrap';

import { auth } from '../../auth';
import { config } from '../../config';
import { LOGIN_ROUTE } from '../../constants';

import './auth.css';

const logoUrl = config.getLogoUrl();

export default class Login extends PureComponent {
  static propTypes = {
    authentication: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    checkLogin: PropTypes.func.isRequired,
    requestLogin: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = { email: '', password: '' };
  }

  emailChanged = (event) => {
    this.setState({email: event.target.value});
  }

  passwordChanged = (event) => {
    this.setState({password: event.target.value});
  }

  handleSubmit = (event) => {
    const { requestLogin } = this.props;
    const { email, password } = this.state;

    event.preventDefault();

    requestLogin(email, password);
  }

  componentWillMount() {
    auth.addExternalAuthenticationChangedListener(this.externalAuthenticationChanged);

    const { authentication, checkLogin } = this.props;
    this.redirectIfNecessaryAfterLogin(authentication);
    checkLogin();
  }

  componentWillReceiveProps(nextProps) {
    const { authentication } = nextProps;
    if (authentication !== this.props.authentication) {
      this.redirectIfNecessaryAfterLogin(authentication);
    }
  }

  componentWillUnmount() {
    auth.removeExternalAuthenticationChangedListener(this.externalAuthenticationChanged);
  }

  externalAuthenticationChanged = () => {
    const { checkLogin } = this.props;
    checkLogin();
  }

  redirectIfNecessaryAfterLogin(authentication) {
    if (authentication.get('authenticated') === true && authentication.get('loading') === false) {
      const { history, location } = this.props;

      let replacePath = '/';

      if (location.state && location.state.nextPathname) {
        let nextPath = location.state.nextPathname;
        // react-router often strips the leading '/' from the routes, so we need to add it here to check...
        if (LOGIN_ROUTE.charAt(0) === '/' && nextPath.charAt(0) !== '/') {
          nextPath = `/${nextPath}`;
        }
        if (nextPath !== LOGIN_ROUTE) {
          replacePath = nextPath;
        }
      }

      history.replace(replacePath);
    }
  }

  render() {
    const { authentication } = this.props;
    const loadingError = authentication.get('loadingError');
    const loading = authentication.get('loading');

    const { email, password } = this.state;

    const logo = logoUrl ? (
      <div className="login-logo">
        <img src={logoUrl}/>
      </div>
    ) : false;

    const errorMessage = loadingError ? (
      <FormGroup>
        <Col sm={12}>
          <FormFeedback>Please try again</FormFeedback>
        </Col>
      </FormGroup>
    ) : false;

    let formGroupClassName = loadingError ? 'form-group-error' : null;

    return (
      <div className="login-background">
        <div className="container">
          <div className="login-form">
            {logo}
            <Col sm={12}>
              <div className="login-heading">Please sign in</div>
            </Col>
            <Form>
              <FormGroup className={formGroupClassName}>
                <Col sm={12}>
                  <Input id="login-email" type="text" placeholder="Email" value={email} onChange={this.emailChanged}/>
                </Col>
              </FormGroup>
              <FormGroup className={formGroupClassName}>
                <Col sm={12}>
                  <Input id="login-password" type="password" placeholder="Password" value={password} onChange={this.passwordChanged}/>
                </Col>
              </FormGroup>
              {errorMessage}
              <FormGroup>
                <Col sm={12}>
                  <Button disabled={loading} color="primary" type="submit" onClick={this.handleSubmit}>
                    Sign in
                  </Button>
                </Col>
              </FormGroup>
            </Form>
          </div>
        </div>
      </div>
    );
  }
}
